import {State} from '../index';
import {userFeatureKey, UserState} from './user.reducer';
import {createSelector} from '@ngrx/store';

export const selectUserState = (state: State): UserState => state[userFeatureKey];

export const selectUserSubstitutees = createSelector(
  selectUserState,

  (userState: UserState) => userState.substitutees
);

export const selectUserInitialized = createSelector(
  selectUserState,

  (userState: UserState) => userState.initialized
);

export const selectUserWithSubstitutees = createSelector(
  selectUserState,

  (userState: UserState) => [...(userState.user ? [userState.user] : []), ...(userState.substitutees || [])]
);

export const selectUserTheme = createSelector(
  selectUserState,

  (userState: UserState) => userState.theme
);
export const selectUserSettings = createSelector(
  selectUserState,

  (userState: UserState) => userState.settings
);
